import {
    handleDeleteIconMouseEnter,
    handleEnabledIconMouseEnter as handleEnabledMouseEnter,
    handleEnabledIconMouseLeave as handleEnabledMouseLeave,
    handleIconMouseEnter,
    handleIconMouseLeave,
    uiStyles
} from 'lib/uiUtils';
import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    getResponseData,
    validateSchemaFields
} from 'lib/formUtils';
import {
    formatData,
    getCodEmpresa,
    getCodUsuarioRegistrou,
    getCurrencyInputValue,
    getDateInputValue,
    getInputValue,
    getOnlyDigits,
    isMissingValue,
    parseCurrencyInputValue,
    validarCPF
} from 'lib/functions';
import {
    ComboPadrao,
    FileField,
    FormActions,
    FormStatusSwitch,
    FormTextArea
} from 'views/Components';
import {
    AppBar,
    Box,
    Button,
    CardContent,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormLabel,
    InputAdornment,
    Paper,
    Radio,
    RadioGroup,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import {
    DeleteForeverOutlined,
    EditTwoTone,
    LocalTaxiOutlined,
    SearchRounded,
    VisibilityOutlined,
    VisibilityOffOutlined
} from '@material-ui/icons';
import theme from 'theme';
import api from 'services/api';
import PropTypes from 'prop-types';
import { ANAO, ASIM } from 'consts';
import React, { Component } from 'react';
import { safeSetState } from 'lib/reactUtils';
import { validateComboFields } from 'lib/configUtils';
import { AlertInformation, DeleteConfirmationModal } from 'components';

/* Campos que seguem uppercase */
const UPPERCASE_FIELDS = [
    'nome',
    'email',
    'logradouro',
    'numero',
    'bairro',
    'complemento',
    'ctps',
    'seriectps',
    'ufctps'
];

/* Opções de escolaridade */
const ESCOLARIDADES = [
    {
        value: 1,
        label: '1º Grau'
    },
    {
        value: 2,
        label: '2º Grau'
    },
    {
        value: 3,
        label: 'Superior'
    },
    {
        value: 4,
        label: 'Pós Graduação'
    },
    {
        value: 5,
        label: 'Mestrado'
    },
    {
        value: 6,
        label: 'Doutorado'
    }
];

/* Opções de segurança da conexão do e-mail */
const SEGURANCAS_CONEXAO = [
    {
        value: 0,
        label: 'SSLV2'
    },
    {
        value: 1,
        label: 'SSLV23'
    },
    {
        value: 2,
        label: 'SSLV3'
    },
    {
        value: 3,
        label: 'SSLVTLSV1'
    }
];

/* Retorna o funcionário padrão */
const getFuncionarioDefault = () => ({
    codfuncionario: '',
    nome: '',
    inativo: ANAO,
    codcargo: '',
    codsetor: '',
    cpf: '',
    cep: '',
    logradouro: '',
    numero: '',
    bairro: '',
    complemento: '',
    codcidade: '',
    foneresidencial: '',
    fonecelular: '',
    nextel: '',
    passaporte: '',
    email: '',
    datanasc: '',
    idnacionalidade: '',
    perccomissao: '',
    obs: '',
    escolaridade: '',
    escolaridadecompleta: '',
    salario: '',
    dataadmissao: '',
    custohora: '',
    cargahorariadiaria: '00:00',
    ctps: '',
    seriectps: '',
    ufctps: '',
    matriculaesocial: '',
    nomeremetemailenviofunc: '',
    emailenviofunc: '',
    nomeusuarioemailenviofunc: '',
    senhaemailenviofunc: '',
    smtpemailfunc: '',
    portasmtpemailfunc: '',
    servreqautentemailfunc: ANAO,
    servreqconexsslemailfunc: ANAO,
    servreqconextlsemailfunc: ANAO,
    segconexemailfunc: '',
    textopadraocorpoemail: '',
    possuiurlassinatura: ANAO,
    urlassinatura: '',
    usaimapcopiasaida: ANAO,
    hostimap: '',
    portaimap: ''
});

/* Retorna o documento padrão */
const getDocumentoDefault = () => ({
    chave: '',
    descricao: '',
    descritivodoc: '',
    vencimento: '',
    avisodiasantecedencia: '',
    localdocts: '',
    localdocredeint: '',
    inativodoc: ANAO
});

/* Aplica a máscara de CPF (999.999.999-99) */
const maskCPF = (value) => {
    const digits = getOnlyDigits(value).slice(0, 11);

    return digits.replace(/^(\d{3})(\d)/, '$1.$2').replace(
        /^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3'
    ).replace(/\.(\d{3})(\d)/, '.$1-$2');
};

/* Aplica a máscara de CEP (99999-999) */
const maskCEP = (value) => {
    const digits = getOnlyDigits(value).slice(0, 8);

    return digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
};

/* Remove os acentos e padroniza o texto pra comparação */
const normalizeText = (value) => {
    return String(value || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().trim();
};

function TabContainer(props) {
    return (
        <Typography component="div">
            {props.children}
        </Typography>
    );
};

TabContainer.propTypes = {
    children: PropTypes.node.isRequired
};

class FuncionarioForm extends Component {
    state = {
        activeTab: 0,
        emailTab: 0,
        isLoading: true,
        isNewRecord: false,
        isView: false,
        openAlert: false,
        messageAlert: '',
        showSenha: false,
        openConfirmMotorista: false,
        openModalDocumentos: false,
        openConfirmRemoveDocumentoTS: false,
        openConfirmRemoveDocumentoRedeInterna: false,
        openConfirmDeleteDocumento: false,
        documentoASerExcluido: null,
        documentoChaveASerExcluida: '',
        documentoDescASerExcluido: '',
        cargos: [],
        cidades: [],
        nacionalidades: [],
        setores: [],
        documentosfuncionario: [],
        errors: {},
        funcionario: getFuncionarioDefault(),
        documento: getDocumentoDefault(),
        schemaFuncionario: {
            nome: {
                presence: {
                    allowEmpty: false,
                    message: 'Nome do funcionário obrigatório'
                },
                length: { maximum: 100 },
                type: 'string'
            },
            codcargo: {
                presence: {
                    allowEmpty: false,
                    message: 'Cargo do funcionário obrigatório'
                },
                type: 'integer'
            },
            codsetor: {
                presence: {
                    allowEmpty: false,
                    message: 'Setor do funcionário obrigatório'
                },
                type: 'integer'
            }
        },
        schemaDocumento: {
            descricao: {
                presence: {
                    allowEmpty: false,
                    message: 'Descrição do documento obrigatória'
                },
                length: { maximum: 50 },
                type: 'string'
            }
        }
    };

    estilo = uiStyles;

    _isMounted = false;
    safeSetState = safeSetState;

    /* Inserção de files */
    inputFileDocumentoTSRef = React.createRef();
    inputFileDocumentoRedeInternaRef = React.createRef();

    /* Eventos dos ícones condicionados ao modo de visualização */
    // ao passar o cursor
    handleFieldIconMouseEnter = (event) => {
        handleEnabledMouseEnter(event, this.state.isView);
    };

    // ao remover o cursor
    handleFieldIconMouseLeave = (event) => {
        handleEnabledMouseLeave(event, this.state.isView);
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            if (isNewRecord) {
                const [cargos, setores, nacionalidades, cidades] = await Promise.all([
                    this.loadCargos(),
                    this.loadSetores(),
                    this.loadNacionalidades(),
                    this.loadCidades()
                ]);

                this.safeSetState({
                    isNewRecord: true,
                    isView: false,
                    isLoading: false,
                    funcionario: getFuncionarioDefault(),
                    cargos,
                    setores,
                    nacionalidades,
                    cidades
                });

                return;
            }

            if (!isNaN(Number(id))) {
                await this.loadFuncionario(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar o funcionário:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(error, 'Erro ao carregar o funcionário!')
            );

            this.safeSetState({ isLoading: false });
        }
    };

    /* Limpa a flag de montagem ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Carrega os cargos */
    loadCargos = async (codcargo) => {
        const url = codcargo ? `/cargo/listforchange/${codcargo}` : '/cargo/active/true';
        const response = await api.get(url);

        return getResponseData(response);
    };

    /* Carrega os setores */
    loadSetores = async (codsetor) => {
        const url = codsetor ? `/setor/listforchange/${codsetor}` : '/setor/active/true';
        const response = await api.get(url);

        return getResponseData(response);
    };

    /* Carrega as nacionalidades */
    loadNacionalidades = async (idnacionalidade) => {
        const url = idnacionalidade
            ? `/nacionalidade/listforchange/${idnacionalidade}`
            : '/nacionalidade/active/true';

        const response = await api.get(url);

        return getResponseData(response);
    };

    /* Carrega as cidades */
    loadCidades = async (codcidade) => {
        const url = codcidade
            ? `/cidade/listforchange/${codcidade}`
            : '/cidade/active/true?limit=10000';
        const response = await api.get(url);
        const cidades = getResponseData(response);

        // monta a descrição já com a UF pro combo
        return cidades.map(cidade => ({
            ...cidade,
            desccidadeuf: cidade.sigla
                ? `${cidade.desccidade} (${cidade.sigla})`
                : cidade.desccidade
        }));
    };

    /* Carrega o funcionário */
    loadFuncionario = async (id, isView) => {
        const { history } = this.props;

        const response = await api.get(`/funcionario/${id}`);
        const registro = getRecordFromResponse(response);

        if (!registro) {
            this.handleOpenAlert('Funcionário não encontrado!');

            history.push(this.getBasePath());

            return;
        }

        const [cargos, setores, nacionalidades, cidades] = await Promise.all([
            this.loadCargos(registro.codcargo),
            this.loadSetores(registro.codsetor),
            this.loadNacionalidades(registro.idnacionalidade),
            this.loadCidades(registro.codcidade)
        ]);

        this.safeSetState({
            funcionario: this.normalizaFuncionario(registro),
            cargos,
            setores,
            nacionalidades,
            cidades,
            isNewRecord: false,
            isView,
            isLoading: false
        });

        this.listaDocumentos(registro.codfuncionario);
    };

    /* Normaliza o registro vindo do backend (null vira vazio, ids viram string) */
    normalizaFuncionario = (registro) => {
        const padrao = getFuncionarioDefault();

        const camposId = [
            'codcargo',
            'codsetor',
            'codcidade',
            'idnacionalidade'
        ];

        const funcionario = { ...padrao };

        Object.keys(padrao).forEach(campo => {
            const valor = registro[campo];

            if (valor === null || valor === undefined) {
                return;
            }

            funcionario[campo] = camposId.includes(campo) ? String(valor) : valor;
        });

        return {
            ...funcionario,
            inativo: registro.inativo || ANAO,
            cpf: maskCPF(registro.cpf),
            cep: getOnlyDigits(registro.cep),
            cargahorariadiaria: registro.cargahorariadiaria || '00:00',
            servreqautentemailfunc: registro.servreqautentemailfunc || ANAO,
            servreqconexsslemailfunc: registro.servreqconexsslemailfunc || ANAO,
            servreqconextlsemailfunc: registro.servreqconextlsemailfunc || ANAO,
            possuiurlassinatura: registro.possuiurlassinatura || ANAO,
            usaimapcopiasaida: registro.usaimapcopiasaida || ANAO
        };
    };

    /* Lista os documentos na grid */
    listaDocumentos = async (codfuncionarioParam) => {
        const { funcionario } = this.state;
        const codfuncionario = codfuncionarioParam || funcionario.codfuncionario;

        if (!codfuncionario) return;

        try {
            const response = await api.get(`/docfuncionario?codfuncionario=${codfuncionario}`);

            this.safeSetState({ documentosfuncionario: getResponseData(response) });
        } catch (error) {
            console.error('Erro ao buscar documentos do funcionário:', error);

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao listar documentos do funcionário!'
                )
            );
        }
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { errors } = this.state;
        const { name, type, value, checked } = event.target;

        if (errors[name]) {
            this.setState(prev => ({
                errors: {
                    ...prev.errors,
                    [name]: undefined
                }
            }));
        }

        let adjustedValue;

        if (type === 'checkbox' && name === 'inativo') {
            adjustedValue = checked ? ANAO : ASIM;
        } else if (type === 'checkbox') {
            adjustedValue = checked ? ASIM : ANAO;
        } else if (UPPERCASE_FIELDS.includes(name)) {
            adjustedValue = String(value).toUpperCase();
        } else {
            adjustedValue = value;
        }

        this.setState(prevState => ({
            funcionario: {
                ...prevState.funcionario,
                [name]: adjustedValue
            }
        }));
    };

    /* Aplica a máscara de CPF */
    handleChangeCPF = (event) => {
        const { errors } = this.state;
        const cpf = maskCPF(event.target.value);

        if (errors.cpf) {
            this.setState(prev => ({
                errors: {
                    ...prev.errors,
                    cpf: undefined
                }
            }));
        }

        this.setState(prevState => ({
            funcionario: {
                ...prevState.funcionario,
                cpf
            }
        }));
    };

    /* Mantém o CEP somente com dígitos */
    handleChangeCEP = (event) => {
        const { errors } = this.state;
        const cep = getOnlyDigits(event.target.value).slice(0, 8);

        if (errors.cep) {
            this.setState(prev => ({
                errors: {
                    ...prev.errors,
                    cep: undefined
                }
            }));
        }

        this.setState(prevState => ({
            funcionario: {
                ...prevState.funcionario,
                cep
            }
        }));
    };

    /* Aceita somente dígitos */
    handleNumericChange = (event) => {
        const { name, value } = event.target;
        const onlyDigits = getOnlyDigits(value);

        this.setState(prev => ({
            funcionario: {
                ...prev.funcionario,
                [name]: onlyDigits
            }
        }));
    };

    /* Trata os campos monetários */
    handleChangeValorMonetario = (event) => {
        const { name, value } = event.target;
        const numero = parseCurrencyInputValue(value);

        this.setState(prevState => ({
            funcionario: {
                ...prevState.funcionario,
                [name]: numero
            }
        }));
    };

    /* Aplica a máscara HH:MM na carga horária diária */
    handleChangeCargaHoraria = (event) => {
        const digits = getOnlyDigits(event.target.value).slice(0, 4);
        const cargahorariadiaria = digits.length > 2
            ? `${digits.slice(0, 2)}:${digits.slice(2)}`
            : digits;

        this.setState(prevState => ({
            funcionario: {
                ...prevState.funcionario,
                cargahorariadiaria
            }
        }));
    };

    /* Completa a carga horária diária ao sair do campo */
    handleBlurCargaHoraria = () => {
        const { funcionario } = this.state;
        const digits = getOnlyDigits(funcionario.cargahorariadiaria).padEnd(4, '0').slice(0, 4);

        this.setState(prevState => ({
            funcionario: {
                ...prevState.funcionario,
                cargahorariadiaria: digits ? `${digits.slice(0, 2)}:${digits.slice(2)}` : '00:00'
            }
        }));
    };

    /* Marca a conexão SSL ou TLS (não podem ser marcadas juntas) */
    handleChangeConexaoSegura = (event) => {
        const { name, checked } = event.target;

        const outro = name === 'servreqconexsslemailfunc'
            ? 'servreqconextlsemailfunc'
            : 'servreqconexsslemailfunc';

        this.setState(prevState => ({
            funcionario: {
                ...prevState.funcionario,
                [name]: checked ? ASIM : ANAO,
                [outro]: checked ? ANAO : prevState.funcionario[outro]
            }
        }));
    };

    /* Exibe ou oculta a senha do e-mail */
    handleToggleSenha = () => {
        if (!this.state.isView) {
            this.setState(prevState => ({ showSenha: !prevState.showSenha }));
        }
    };

    /* Retorna o UF da cidade selecionada, só pra exibição */
    getUfAtual = () => {
        const { cidades, funcionario } = this.state;

        const cidadeSelecionada = cidades.find(
            item => String(item.codcidade) === String(funcionario.codcidade)
        );

        return cidadeSelecionada?.sigla || '';
    };

    /* Busca o endereço pelo CEP (ViaCEP) */
    handleBuscaCep = async () => {
        const { cidades, funcionario, isView } = this.state;
        const cep = getOnlyDigits(funcionario.cep);

        if (isView) return;

        if (cep.length !== 8) {
            this.handleOpenAlert('Informe um CEP com 8 dígitos!');

            return;
        }

        try {
            const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
            const dados = await response.json();

            if (!response.ok || dados.erro) {
                this.handleOpenAlert('CEP não encontrado!');

                return;
            }

            const cidadeEncontrada = cidades.find(
                cidade => normalizeText(cidade.desccidade) === normalizeText(
                    dados.localidade
                ) && normalizeText(cidade.sigla) === normalizeText(dados.uf)
            );

            this.setState(prevState => ({
                funcionario: {
                    ...prevState.funcionario,
                    logradouro: String(dados.logradouro || '').toUpperCase(),
                    bairro: String(dados.bairro || '').toUpperCase(),
                    complemento: dados.complemento
                        ? String(dados.complemento).toUpperCase()
                        : prevState.funcionario.complemento,
                    codcidade: cidadeEncontrada
                        ? String(cidadeEncontrada.codcidade)
                        : prevState.funcionario.codcidade
                }
            }));

            if (!cidadeEncontrada) {
                this.handleOpenAlert(
                    'Endereço preenchido, mas a cidade não foi localizada. Selecione-a manualmente!'
                );
            }
        } catch (error) {
            console.error('Erro ao buscar o CEP:', error);

            this.handleOpenAlert('Erro ao buscar o CEP!');
        }
    };

    /* Evento onChange componentes documentos */
    onChangeDocumento = (event) => {
        const { name, type, value, checked } = event.target;

        // não converter para uppercase
        if (name === 'descritivodoc') {
            this.setState(prevState => ({
                documento: {
                    ...prevState.documento,
                    [name]: value
                }
            }));

            return;
        }

        let adjustedValue;

        if (type === 'checkbox' && name === 'inativodoc') {
            adjustedValue = checked ? ANAO : ASIM;
        } else if (type === 'checkbox') {
            adjustedValue = checked ? ASIM : ANAO;
        } else if (name === 'descricao') {
            adjustedValue = value.toUpperCase();
        } else {
            adjustedValue = value;
        }

        this.setState(prevState => ({
            documento: {
                ...prevState.documento,
                [name]: adjustedValue
            }
        }));
    };

    /* Trata os campos numéricos positivos de documento */
    handlePositiveNumberDocumentoChange = (event) => {
        const valor = parseInt(event.target.value);

        if (valor >= 1 || event.target.value === '') {
            this.onChangeDocumento(event);
        }
    };

    /* Seleciona o arquivo TS de documento */
    handleFileDocumentoTS = (event) => {
        const file = event.target.files[0];

        if (file) {
            this.setState(prevState => ({
                documento: {
                    ...prevState.documento,
                    localdocts: file.name
                }
            }));
        }
    };

    /* Remove o arquivo TS de documento */
    handleDeleteFileDocumentoTS = () => {
        this.setState(prevState => ({
            documento: {
                ...prevState.documento,
                localdocts: ''
            }
        }), () => {
            if (this.inputFileDocumentoTSRef.current) {
                this.inputFileDocumentoTSRef.current.value = null;
            }
        });
    };

    /* Abre a confirmação de remoção do arquivo TS de documento */
    handleOpenConfirmRemoveDocumentoTS = () => {
        this.setState({ openConfirmRemoveDocumentoTS: true });
    };

    /* Fecha a confirmação de remoção do arquivo TS de documento */
    handleCloseConfirmRemoveDocumentoTS = () => {
        this.setState({ openConfirmRemoveDocumentoTS: false });
    };

    /* Confirma a remoção do arquivo TS de documento */
    handleConfirmRemoveDocumentoTS = () => {
        this.handleCloseConfirmRemoveDocumentoTS();
        this.handleDeleteFileDocumentoTS();
    };

    /* Seleciona o arquivo de rede interna de documento */
    handleFileDocumentoRedeInterna = (event) => {
        const file = event.target.files[0];

        if (file) {
            this.setState(prevState => ({
                documento: {
                    ...prevState.documento,
                    localdocredeint: file.name
                }
            }));
        }
    };

    /* Remove o arquivo de rede interna de documento */
    handleDeleteFileDocumentoRedeInterna = () => {
        this.setState(prevState => ({
            documento: {
                ...prevState.documento,
                localdocredeint: ''
            }
        }), () => {
            if (this.inputFileDocumentoRedeInternaRef.current) {
                this.inputFileDocumentoRedeInternaRef.current.value = null;
            }
        });
    };

    /* Abre a confirmação de remoção do arquivo de rede interna de documento */
    handleOpenConfirmRemoveDocumentoRedeInterna = () => {
        this.setState({ openConfirmRemoveDocumentoRedeInterna: true });
    };

    /* Fecha a confirmação de remoção do arquivo de rede interna de documento */
    handleCloseConfirmRemoveDocumentoRedeInterna = () => {
        this.setState({ openConfirmRemoveDocumentoRedeInterna: false });
    };

    /* Confirma a remoção do arquivo de rede interna de documento */
    handleConfirmRemoveDocumentoRedeInterna = () => {
        this.handleCloseConfirmRemoveDocumentoRedeInterna();
        this.handleDeleteFileDocumentoRedeInterna();
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Troca a aba superior */
    handleTabChange = (event, newValue) => {
        this.setState({ activeTab: newValue });
    };

    /* Troca a aba de configuração de e-mail */
    handleEmailTabChange = (event, newValue) => {
        this.setState({ emailTab: newValue });
    };

    /* Caminho base da tela */
    getBasePath = () => {
        const path = this.props.match?.path || '/funcionario/:id';

        return path.replace('/:id', '');
    };

    /* Retorna o payload do funcionário */
    getPayloadFuncionario = () => {
        const { funcionario, isNewRecord } = this.state;
        const codusuarioregistrou = getCodUsuarioRegistrou();

        if (isMissingValue(codusuarioregistrou)) {
            throw new Error('Código do usuário não encontrado!');
        }

        const payload = {
            nome: funcionario.nome || '',
            inativo: funcionario.inativo || ANAO,
            codcargo: funcionario.codcargo || '',
            codsetor: funcionario.codsetor || '',
            cpf: funcionario.cpf || '',
            cep: getOnlyDigits(funcionario.cep),
            logradouro: funcionario.logradouro || '',
            numero: funcionario.numero || '',
            bairro: funcionario.bairro || '',
            complemento: funcionario.complemento || '',
            codcidade: funcionario.codcidade || '',
            foneresidencial: funcionario.foneresidencial || '',
            fonecelular: funcionario.fonecelular || '',
            nextel: funcionario.nextel || '',
            passaporte: funcionario.passaporte || '',
            email: funcionario.email || '',
            datanasc: funcionario.datanasc || '',
            idnacionalidade: funcionario.idnacionalidade || '',
            perccomissao: funcionario.perccomissao ?? '',
            obs: funcionario.obs || '',
            escolaridade: funcionario.escolaridade ?? '',
            escolaridadecompleta: funcionario.escolaridadecompleta || '',
            salario: funcionario.salario ?? '',
            dataadmissao: funcionario.dataadmissao || '',
            custohora: funcionario.custohora ?? '',
            cargahorariadiaria: funcionario.cargahorariadiaria || '00:00',
            ctps: funcionario.ctps || '',
            seriectps: funcionario.seriectps || '',
            ufctps: funcionario.ufctps || '',
            matriculaesocial: funcionario.matriculaesocial || '',
            nomeremetemailenviofunc: funcionario.nomeremetemailenviofunc || '',
            emailenviofunc: funcionario.emailenviofunc || '',
            nomeusuarioemailenviofunc: funcionario.nomeusuarioemailenviofunc || '',
            senhaemailenviofunc: funcionario.senhaemailenviofunc || '',
            smtpemailfunc: funcionario.smtpemailfunc || '',
            portasmtpemailfunc: funcionario.portasmtpemailfunc ?? '',
            servreqautentemailfunc: funcionario.servreqautentemailfunc || ANAO,
            servreqconexsslemailfunc: funcionario.servreqconexsslemailfunc || ANAO,
            servreqconextlsemailfunc: funcionario.servreqconextlsemailfunc || ANAO,
            segconexemailfunc: funcionario.segconexemailfunc ?? '',
            textopadraocorpoemail: funcionario.textopadraocorpoemail || '',
            possuiurlassinatura: funcionario.possuiurlassinatura || ANAO,
            urlassinatura: funcionario.possuiurlassinatura === ASIM
                ? funcionario.urlassinatura || '' : '',
            usaimapcopiasaida: funcionario.usaimapcopiasaida || ANAO,
            hostimap: funcionario.hostimap || '',
            portaimap: funcionario.portaimap ?? '',
            codusuarioregistrou
        };

        // o vínculo com a empresa só é criado na inserção
        if (isNewRecord) {
            payload.codempresa = getCodEmpresa();
        }

        return payload;
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { funcionario, schemaFuncionario } = this.state;

        return validateSchemaFields(
            funcionario,
            schemaFuncionario,
            [
                'nome',
                'codcargo',
                'codsetor'
            ]
        );
    };

    /* Valida os campos obrigatórios ao salvar o documento */
    validationRequiredFieldsDocumentos() {
        const { documento, schemaDocumento } = this.state;

        return validateSchemaFields(
            documento,
            schemaDocumento,
            ['descricao']
        );
    };

    /* Valida os formatos dos campos informados (CPF, CEP e carga horária) */
    validationFormatFields = () => {
        const { funcionario } = this.state;
        const errors = {};
        const cpf = getOnlyDigits(funcionario.cpf);
        const cep = getOnlyDigits(funcionario.cep);

        if (cpf && !validarCPF(cpf)) {
            errors.cpf = 'CPF inválido';
        }

        if (cep && cep.length !== 8) {
            errors.cep = 'CEP deve ter 8 dígitos';
        }

        if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(funcionario.cargahorariadiaria || '00:00')) {
            errors.cargahorariadiaria = 'Carga horária inválida (HH:MM)';
        }

        return errors;
    };

    /* Sincroniza os documentos pendentes com o funcionário salvo */
    sincronizaDocumentos = async (codfuncionario) => {
        const { documentosfuncionario } = this.state;

        if (!codfuncionario) return;

        const listaDocumentos = Array.isArray(documentosfuncionario) ? documentosfuncionario : [];

        const documentosPendentes = listaDocumentos.filter(
            doc => !doc.chave || String(doc.chave).startsWith('tmp-doc-')
        );

        const codusuarioregistrou = getCodUsuarioRegistrou();

        for (const doc of documentosPendentes) {
            await api.post('/docfuncionario', {
                descricao: doc.descricao || '',
                descritivodoc: doc.descritivodoc || '',
                vencimento: doc.vencimento || '',
                avisodiasantecedencia: doc.avisodiasantecedencia || '',
                localdocts: doc.localdocts || '',
                localdocredeint: doc.localdocredeint || '',
                inativodoc: doc.inativodoc || ANAO,
                codusuarioregistrou,
                codfuncionario
            });
        }

        await this.listaDocumentos(codfuncionario);
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { funcionario, isNewRecord } = this.state;
        const { history, loadFuncionarios } = this.props;

        const errors = {
            ...this.validationRequiredFields(),
            ...this.validationFormatFields()
        };

        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        const comboErrors = validateComboFields(funcionario, [
            {
                field: 'codcargo',
                message: 'Selecione um cargo válido'
            },
            {
                field: 'codsetor',
                message: 'Selecione um setor válido'
            }
        ]);

        if (Object.keys(comboErrors).length > 0) {
            this.setState(prev => ({
                errors: {
                    ...prev.errors,
                    ...comboErrors
                }
            }));

            this.handleOpenAlert(
                'Selecione registros válidos nos campos indicados em vermelho!'
            );

            return;
        }

        try {
            let codfuncionarioSalvo = funcionario.codfuncionario;

            const payload = this.getPayloadFuncionario();

            if (isNewRecord) {
                const response = await api.post('/funcionario', payload);

                codfuncionarioSalvo = response?.data?.codfuncionario;

                if (!codfuncionarioSalvo) {
                    throw new Error(
                        'O funcionário foi enviado, mas o código salvo não foi retornado pelo backend!'
                    );
                }
            } else {
                await api.put(`/funcionario/${funcionario.codfuncionario}`, payload);
            }

            if (loadFuncionarios) loadFuncionarios();

            await this.sincronizaDocumentos(codfuncionarioSalvo);

            history.push(this.getBasePath());
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                getApiErrorMessage(error, 'Erro ao salvar!')
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push(this.getBasePath());
    };

    /* Abre a confirmação de cadastro do motorista fornecedor */
    handleOpenConfirmMotorista = () => {
        if (!this.state.isView) {
            this.setState({ openConfirmMotorista: true });
        }
    };

    /* Fecha a confirmação de cadastro do motorista fornecedor */
    handleCloseConfirmMotorista = () => {
        this.setState({ openConfirmMotorista: false });
    };

    /* Cadastra o funcionário também como motorista fornecedor */
    handleConfirmMotorista = async () => {
        const { funcionario } = this.state;

        this.handleCloseConfirmMotorista();

        try {
            const codusuarioregistrou = getCodUsuarioRegistrou();

            if (isMissingValue(codusuarioregistrou)) {
                throw new Error('Código do usuário não encontrado!');
            }

            const response = await api.post(
                `/funcionario/${funcionario.codfuncionario}/motorista-fornecedor`,
                { codusuarioregistrou }
            );

            this.handleOpenAlert(
                response?.data?.message ||
                'Funcionário cadastrado como motorista fornecedor com sucesso!'
            );
        } catch (error) {
            console.error(
                'Erro ao cadastrar motorista fornecedor:', error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao cadastrar o funcionário como motorista fornecedor!'
                )
            );
        }
    };

    /* Modal de documentos */
    handleOpenModalDocumentos = () => {
        this.setState({
            documento: getDocumentoDefault(),
            errors: {},
            openModalDocumentos: true
        });
    };

    /* Fecha o modal de documentos */
    handleCloseModalDocumentos = () => {
        this.setState({
            documento: getDocumentoDefault(),
            errors: {},
            openModalDocumentos: false
        });
    };

    /* Altera o documento */
    handleChangeDocumento = (doc) => {
        this.setState({
            documento: {
                ...getDocumentoDefault(),
                ...doc
            },
            openModalDocumentos: true
        });
    };

    /* Clicar para salvar o documento */
    onClickSaveDocumento = async () => {
        const { documento, funcionario } = this.state;

        const errors = this.validationRequiredFieldsDocumentos();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        try {
            const codusuarioregistrou = getCodUsuarioRegistrou();

            // funcionário novo: guarda o documento localmente até salvar o funcionário
            if (!funcionario.codfuncionario) {
                const chaveTemporaria = documento.chave && String(
                    documento.chave
                ).startsWith('tmp-doc-') ? documento.chave : `tmp-doc-${Date.now()}`;

                const documentoLocal = {
                    ...documento,
                    chave: chaveTemporaria,
                    codfuncionario: '',
                    codusuarioregistrou: Number(codusuarioregistrou)
                };

                this.setState(prevState => {
                    const jaExiste = prevState.documentosfuncionario.some(
                        doc => String(doc.chave) === String(chaveTemporaria)
                    );

                    const documentosfuncionario = jaExiste ? prevState.documentosfuncionario.map(
                        doc => String(doc.chave) === String(chaveTemporaria)
                            ? documentoLocal : doc
                    ) : [...prevState.documentosfuncionario, documentoLocal];

                    return {
                        documentosfuncionario,
                        documento: getDocumentoDefault(),
                        errors: {},
                        openModalDocumentos: false
                    };
                });

                return;
            }

            const payload = {
                descricao: documento.descricao || '',
                descritivodoc: documento.descritivodoc || '',
                vencimento: documento.vencimento || '',
                avisodiasantecedencia: documento.avisodiasantecedencia || '',
                localdocts: documento.localdocts || '',
                localdocredeint: documento.localdocredeint || '',
                inativodoc: documento.inativodoc || ANAO,
                codusuarioregistrou,
                codfuncionario: funcionario.codfuncionario
            };

            let response;

            if (documento.chave) {
                response = await api.put(`/docfuncionario/${documento.chave}`, payload);
            } else {
                response = await api.post('/docfuncionario', payload);
            }

            if (response.status === 200) {
                await this.listaDocumentos();

                this.safeSetState({
                    documento: getDocumentoDefault(),
                    errors: {},
                    openModalDocumentos: false
                });
            } else {
                this.handleOpenAlert('Erro ao salvar documento!');
            }
        } catch (error) {
            console.error('Erro ao salvar documento:', error);

            this.handleOpenAlert(
                getApiErrorMessage(error, 'Erro ao salvar documento!')
            );
        }
    };

    /* Abre o modal para a exclusão do documento */
    handleOpenDeleteDocumento = (chave, descricao, chaveExibicao) => {
        this.setState({
            openConfirmDeleteDocumento: true,
            documentoASerExcluido: chave,
            documentoChaveASerExcluida: chaveExibicao || chave,
            documentoDescASerExcluido: descricao || ''
        });
    };

    /* Fecha o modal de exclusão do documento */
    handleCloseDeleteDocumento = () => {
        this.setState({
            openConfirmDeleteDocumento: false,
            documentoASerExcluido: null,
            documentoChaveASerExcluida: '',
            documentoDescASerExcluido: ''
        });
    };

    /* Confirma a exclusão do documento */
    handleConfirmDeleteDocumento = async () => {
        const { documentoASerExcluido } = this.state;

        if (!documentoASerExcluido) {
            this.handleOpenAlert('Chave do documento inválida!');

            return;
        }

        // documento ainda não salvo: só remove da grid
        if (String(documentoASerExcluido).startsWith('tmp-doc-')) {
            this.setState(prevState => ({
                documentosfuncionario: prevState.documentosfuncionario.filter(
                    doc => String(doc.chave) !== String(documentoASerExcluido)
                ),
                openConfirmDeleteDocumento: false,
                documentoASerExcluido: null,
                documentoChaveASerExcluida: '',
                documentoDescASerExcluido: ''
            }));

            return;
        }

        try {
            await api.delete(`/docfuncionario/${documentoASerExcluido}`);
            await this.listaDocumentos();

            this.safeSetState({
                openConfirmDeleteDocumento: false,
                documentoASerExcluido: null,
                documentoChaveASerExcluida: '',
                documentoDescASerExcluido: ''
            });
        } catch (error) {
            console.error('Erro ao excluir documento:', error);

            this.handleOpenAlert(
                getApiErrorMessage(error, 'Erro ao excluir o documento!')
            );

            this.safeSetState({ openConfirmDeleteDocumento: false });
        }
    };

    render() {
        const {
            activeTab,
            cargos,
            cidades,
            documento,
            documentoASerExcluido,
            documentoChaveASerExcluida,
            documentoDescASerExcluido,
            documentosfuncionario,
            emailTab,
            errors,
            funcionario,
            isLoading,
            isNewRecord,
            isView,
            messageAlert,
            nacionalidades,
            openAlert,
            openConfirmDeleteDocumento,
            openConfirmMotorista,
            openModalDocumentos,
            openConfirmRemoveDocumentoRedeInterna,
            openConfirmRemoveDocumentoTS,
            setores,
            showSenha
        } = this.state;

        if (isLoading) {
            return (
                <CardContent>
                    <Typography variant="body1">
                        Carregando funcionário...
                    </Typography>
                </CardContent>
            );
        }

        const {
            actionIcon,
            disabledActionIcon,
            iconGroup
        } = this.estilo;

        const ufAtual = this.getUfAtual();

        const titulo = (
            <Typography
                component="h1"
                variant="h3"
            >
                Funcionário {funcionario.codfuncionario}
            </Typography>
        );

        return (
            <div>
                <AppBar
                    position="static"
                    color="default"
                >
                    <Tabs
                        value={activeTab}
                        onChange={this.handleTabChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <Tab
                            label="Geral"
                        />

                        <Tab
                            label="RH"
                        />

                        <Tab
                            label="Configuração e-mail"
                        />

                        <Tab
                            label="Documentos"
                        />
                    </Tabs>
                </AppBar>

                {/* ABA GERAL */}
                {activeTab === 0 &&
                    <TabContainer>
                        <CardContent>
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                style={{
                                    flexWrap: 'wrap',
                                    gap: 12
                                }}
                            >
                                {titulo}

                                <Box
                                    display="flex"
                                    alignItems="center"
                                    style={{
                                        flexWrap: 'wrap',
                                        gap: 12
                                    }}
                                >
                                    {!isNewRecord && (
                                        <Tooltip title="Cadastrar como motorista fornecedor">
                                            <LocalTaxiOutlined
                                                onClick={this.handleOpenConfirmMotorista}
                                                onMouseEnter={this.handleFieldIconMouseEnter}
                                                onMouseLeave={this.handleFieldIconMouseLeave}
                                                style={{
                                                    ...actionIcon,
                                                    fontSize: 28,
                                                    ...(isView ? disabledActionIcon : {})
                                                }}
                                            />
                                        </Tooltip>
                                    )}

                                    <FormStatusSwitch
                                        checked={funcionario.inativo === ANAO}
                                        name="inativo"
                                        onChange={this.onChange}
                                        disabled={isView}
                                    />
                                </Box>
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <TextField
                                    label="Nome"
                                    name="nome"
                                    value={funcionario.nome || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    helperText={errors.nome || ''}
                                    error={!!errors.nome}
                                    disabled={isView}
                                    inputProps={{ maxLength: 100 }}
                                    style={{
                                        flex: 2,
                                        minWidth: 260
                                    }}
                                />

                                <TextField
                                    label="CPF"
                                    name="cpf"
                                    value={funcionario.cpf || ''}
                                    variant="outlined"
                                    onChange={this.handleChangeCPF}
                                    helperText={errors.cpf || ''}
                                    error={!!errors.cpf}
                                    disabled={isView}
                                    inputProps={{ maxLength: 14 }}
                                    style={{
                                        flex: 1,
                                        minWidth: 160
                                    }}
                                />
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <FormControl
                                    variant="outlined"
                                    disabled={isView}
                                    style={{
                                        flex: 1,
                                        minWidth: 220
                                    }}
                                >
                                    <ComboPadrao
                                        name={'codcargo'}
                                        label={'Cargo'}
                                        value={funcionario.codcargo}
                                        onChange={this.onChange}
                                        fieldId={'codcargo'}
                                        listItems={cargos}
                                        fieldDescription={'cargo'}
                                        error={!!errors.codcargo}
                                        helperText={errors.codcargo || ''}
                                    />
                                </FormControl>

                                <FormControl
                                    variant="outlined"
                                    disabled={isView}
                                    style={{
                                        flex: 1,
                                        minWidth: 220
                                    }}
                                >
                                    <ComboPadrao
                                        name={'codsetor'}
                                        label={'Setor'}
                                        value={funcionario.codsetor}
                                        onChange={this.onChange}
                                        fieldId={'codsetor'}
                                        listItems={setores}
                                        fieldDescription={'descsetor'}
                                        error={!!errors.codsetor}
                                        helperText={errors.codsetor || ''}
                                    />
                                </FormControl>
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <TextField
                                    label="CEP"
                                    name="cep"
                                    value={maskCEP(funcionario.cep)}
                                    variant="outlined"
                                    onChange={this.handleChangeCEP}
                                    helperText={errors.cep || ''}
                                    error={!!errors.cep}
                                    disabled={isView}
                                    inputProps={{ maxLength: 9 }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title="Buscar endereço pelo CEP">
                                                    <span>
                                                        <SearchRounded
                                                            onClick={this.handleBuscaCep}
                                                            onMouseEnter={this.handleFieldIconMouseEnter}
                                                            onMouseLeave={this.handleFieldIconMouseLeave}
                                                            style={{
                                                                fontSize: 22,
                                                                marginTop: 4,
                                                                color: isView ? theme.palette.grey[400] : theme.palette.primary.main,
                                                                cursor: isView ? 'default' : 'pointer'
                                                            }}
                                                        />
                                                    </span>
                                                </Tooltip>
                                            </InputAdornment>
                                        )
                                    }}
                                    style={{
                                        flex: 1,
                                        minWidth: 160
                                    }}
                                />

                                <TextField
                                    label="Logradouro"
                                    name="logradouro"
                                    value={funcionario.logradouro || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 100 }}
                                    style={{
                                        flex: 2,
                                        minWidth: 240
                                    }}
                                />

                                <TextField
                                    label="Número"
                                    name="numero"
                                    value={funcionario.numero || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 10 }}
                                    style={{
                                        flex: 1,
                                        minWidth: 100
                                    }}
                                />
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <TextField
                                    label="Bairro"
                                    name="bairro"
                                    value={funcionario.bairro || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 50 }}
                                    style={{
                                        flex: 1,
                                        minWidth: 180
                                    }}
                                />

                                <TextField
                                    label="Complemento"
                                    name="complemento"
                                    value={funcionario.complemento || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 50 }}
                                    style={{
                                        flex: 1,
                                        minWidth: 200
                                    }}
                                />
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <FormControl
                                    variant="outlined"
                                    disabled={isView}
                                    style={{
                                        flex: 2,
                                        minWidth: 240
                                    }}
                                >
                                    <ComboPadrao
                                        name={'codcidade'}
                                        label={'Cidade'}
                                        value={funcionario.codcidade}
                                        onChange={this.onChange}
                                        fieldId={'codcidade'}
                                        listItems={cidades}
                                        fieldDescription={'desccidadeuf'}
                                    />
                                </FormControl>

                                <TextField
                                    label="UF"
                                    value={ufAtual}
                                    variant="outlined"
                                    disabled
                                    style={{
                                        flex: '0 1 100px',
                                        minWidth: 100
                                    }}
                                />
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <TextField
                                    label="Fone residencial"
                                    name="foneresidencial"
                                    value={funcionario.foneresidencial || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    style={{
                                        flex: 1,
                                        minWidth: 160
                                    }}
                                />

                                <TextField
                                    label="Celular"
                                    name="fonecelular"
                                    value={funcionario.fonecelular || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    style={{
                                        flex: 1,
                                        minWidth: 160
                                    }}
                                />

                                <TextField
                                    label="Nextel"
                                    name="nextel"
                                    value={funcionario.nextel || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    style={{
                                        flex: 1,
                                        minWidth: 160
                                    }}
                                />
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <TextField
                                    label="E-mail"
                                    name="email"
                                    value={funcionario.email || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 100 }}
                                    style={{
                                        flex: 2,
                                        minWidth: 240
                                    }}
                                />

                                <TextField
                                    label="Passaporte"
                                    name="passaporte"
                                    value={funcionario.passaporte || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    style={{
                                        flex: 1,
                                        minWidth: 160
                                    }}
                                />
                            </Box>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <TextField
                                    label="Data de nascimento"
                                    name="datanasc"
                                    onChange={this.onChange}
                                    type="date"
                                    value={getDateInputValue(funcionario.datanasc)}
                                    variant="outlined"
                                    disabled={isView}
                                    InputLabelProps={{
                                        shrink: true,
                                        required: false
                                    }}
                                    style={{
                                        flex: 1,
                                        minWidth: 180
                                    }}
                                />

                                <FormControl
                                    variant="outlined"
                                    disabled={isView}
                                    style={{
                                        flex: 1,
                                        minWidth: 220
                                    }}
                                >
                                    <ComboPadrao
                                        name={'idnacionalidade'}
                                        label={'Nacionalidade'}
                                        value={funcionario.idnacionalidade}
                                        onChange={this.onChange}
                                        fieldId={'idnacionalidade'}
                                        listItems={nacionalidades}
                                        fieldDescription={'descnacionalidade'}
                                    />
                                </FormControl>

                                <TextField
                                    label="% Comissão"
                                    name="perccomissao"
                                    value={getCurrencyInputValue(funcionario.perccomissao)}
                                    variant="outlined"
                                    onChange={this.handleChangeValorMonetario}
                                    disabled={isView}
                                    type="text"
                                    style={{
                                        flex: 1,
                                        minWidth: 140
                                    }}
                                />
                            </Box>

                            <br />

                            <Box>
                                <Typography
                                    color="textSecondary"
                                    component="p"
                                    variant="body2"
                                >
                                    Observação
                                </Typography>

                                <FormTextArea
                                    name="obs"
                                    value={funcionario.obs}
                                    onChange={this.onChange}
                                    disabled={isView}
                                    minHeight={80}
                                />
                            </Box>

                            <br />
                            <br />

                            <FormActions
                                onSave={this.onClickSave}
                                onCancel={this.onClickCancel}
                                disableSave={isView}
                            />
                        </CardContent>
                    </TabContainer>
                }

                {/* ABA RH */}
                {activeTab === 1 &&
                    <TabContainer>
                        <CardContent>
                            {titulo}

                            <br />

                            <fieldset
                                style={{
                                    width: '100%',
                                    padding: 22,
                                    borderRadius: 5,
                                    border: `1px solid ${theme.palette.grey[400]}`
                                }}
                            >
                                <legend
                                    style={{
                                        padding: '0 10px',
                                        fontFamily: 'Calibri, sans-serif',
                                        fontWeight: 'bold',
                                        color: theme.palette.grey[600]
                                    }}
                                >
                                    Formação
                                </legend>

                                <Box
                                    display="flex"
                                    flexWrap="wrap"
                                    alignItems="center"
                                    style={{ gap: 12 }}
                                >
                                    <TextField
                                        select
                                        label="Escolaridade"
                                        name="escolaridade"
                                        value={String(funcionario.escolaridade ?? '')}
                                        variant="outlined"
                                        onChange={this.onChange}
                                        disabled={isView}
                                        SelectProps={{ native: true }}
                                        InputLabelProps={{ shrink: true }}
                                        style={{
                                            flex: 1,
                                            minWidth: 200
                                        }}
                                    >
                                        <option
                                            value=""
                                        />

                                        {ESCOLARIDADES.map(item => (
                                            <option
                                                key={item.value}
                                                value={item.value}
                                            >
                                                {item.label}
                                            </option>
                                        ))}
                                    </TextField>

                                    <FormControl
                                        component="fieldset"
                                        disabled={isView}
                                    >
                                        <FormLabel component="legend">
                                            Situação
                                        </FormLabel>

                                        <RadioGroup
                                            row
                                            name="escolaridadecompleta"
                                            value={funcionario.escolaridadecompleta || ''}
                                            onChange={this.onChange}
                                        >
                                            <FormControlLabel
                                                value={ASIM}
                                                label={<span>Completo</span>}
                                                control={
                                                    <Radio
                                                        size="small"
                                                        color="primary"
                                                    />
                                                }
                                            />

                                            <FormControlLabel
                                                value={ANAO}
                                                label={<span>Incompleto</span>}
                                                control={
                                                    <Radio
                                                        size="small"
                                                        color="primary"
                                                    />
                                                }
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </Box>
                            </fieldset>

                            <br />

                            <Box
                                display="flex"
                                flexWrap="wrap"
                                style={{ gap: 12 }}
                            >
                                <TextField
                                    label="Data de admissão"
                                    name="dataadmissao"
                                    onChange={this.onChange}
                                    type="date"
                                    value={getDateInputValue(funcionario.dataadmissao)}
                                    variant="outlined"
                                    disabled={isView}
                                    InputLabelProps={{
                                        shrink: true,
                                        required: false
                                    }}
                                    style={{
                                        flex: 1,
                                        minWidth: 180
                                    }}
                                />

                                <TextField
                                    label="Salário"
                                    name="salario"
                                    value={getCurrencyInputValue(funcionario.salario)}
                                    variant="outlined"
                                    onChange={this.handleChangeValorMonetario}
                                    disabled={isView}
                                    type="text"
                                    style={{
                                        flex: 1,
                                        minWidth: 160
                                    }}
                                />

                                <TextField
                                    label="Custo hora"
                                    name="custohora"
                                    value={getCurrencyInputValue(funcionario.custohora)}
                                    variant="outlined"
                                    onChange={this.handleChangeValorMonetario}
                                    disabled={isView}
                                    type="text"
                                    style={{
                                        flex: 1,
                                        minWidth: 160
                                    }}
                                />

                                <TextField
                                    label="Carga horária diária"
                                    name="cargahorariadiaria"
                                    value={funcionario.cargahorariadiaria || ''}
                                    variant="outlined"
                                    onChange={this.handleChangeCargaHoraria}
                                    onBlur={this.handleBlurCargaHoraria}
                                    helperText={errors.cargahorariadiaria || 'HH:MM'}
                                    error={!!errors.cargahorariadiaria}
                                    disabled={isView}
                                    inputProps={{ maxLength: 5 }}
                                    style={{
                                        flex: 1,
                                        minWidth: 160
                                    }}
                                />
                            </Box>

                            <br />

                            <fieldset
                                style={{
                                    width: '100%',
                                    padding: 22,
                                    borderRadius: 5,
                                    border: `1px solid ${theme.palette.grey[400]}`
                                }}
                            >
                                <legend
                                    style={{
                                        padding: '0 10px',
                                        fontFamily: 'Calibri, sans-serif',
                                        fontWeight: 'bold',
                                        color: theme.palette.grey[600]
                                    }}
                                >
                                    CTPS / e-Social
                                </legend>

                                <Box
                                    display="flex"
                                    flexWrap="wrap"
                                    style={{ gap: 12 }}
                                >
                                    <TextField
                                        label="Número CTPS"
                                        name="ctps"
                                        value={funcionario.ctps || ''}
                                        variant="outlined"
                                        onChange={this.onChange}
                                        disabled={isView}
                                        inputProps={{ maxLength: 20 }}
                                        style={{
                                            flex: 1,
                                            minWidth: 160
                                        }}
                                    />

                                    <TextField
                                        label="Série CTPS"
                                        name="seriectps"
                                        value={funcionario.seriectps || ''}
                                        variant="outlined"
                                        onChange={this.onChange}
                                        disabled={isView}
                                        inputProps={{ maxLength: 10 }}
                                        style={{
                                            flex: 1,
                                            minWidth: 140
                                        }}
                                    />

                                    <TextField
                                        label="UF CTPS"
                                        name="ufctps"
                                        value={funcionario.ufctps || ''}
                                        variant="outlined"
                                        onChange={this.onChange}
                                        disabled={isView}
                                        inputProps={{ maxLength: 2 }}
                                        style={{
                                            flex: '0 1 100px',
                                            minWidth: 90
                                        }}
                                    />

                                    <TextField
                                        label="Matrícula e-Social"
                                        name="matriculaesocial"
                                        value={funcionario.matriculaesocial || ''}
                                        variant="outlined"
                                        onChange={this.onChange}
                                        disabled={isView}
                                        inputProps={{ maxLength: 30 }}
                                        style={{
                                            flex: 1,
                                            minWidth: 180
                                        }}
                                    />
                                </Box>
                            </fieldset>

                            <br />
                            <br />

                            <FormActions
                                onSave={this.onClickSave}
                                onCancel={this.onClickCancel}
                                disableSave={isView}
                            />
                        </CardContent>
                    </TabContainer>
                }

                {/* ABA CONFIGURAÇÃO E-MAIL */}
                {activeTab === 2 &&
                    <TabContainer>
                        <CardContent>
                            {titulo}

                            <br />

                            <Tabs
                                value={emailTab}
                                onChange={this.handleEmailTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                            >
                                <Tab
                                    label="Envio e-mail"
                                />

                                <Tab
                                    label="IMAP"
                                />
                            </Tabs>

                            <br />

                            {/* SUB-ABA ENVIO E-MAIL */}
                            {emailTab === 0 && (
                                <div>
                                    <Box
                                        display="flex"
                                        flexWrap="wrap"
                                        style={{ gap: 12 }}
                                    >
                                        <TextField
                                            label="Nome do remetente"
                                            name="nomeremetemailenviofunc"
                                            value={funcionario.nomeremetemailenviofunc || ''}
                                            variant="outlined"
                                            onChange={this.onChange}
                                            disabled={isView}
                                            inputProps={{ maxLength: 100 }}
                                            style={{
                                                flex: 1,
                                                minWidth: 220
                                            }}
                                        />

                                        <TextField
                                            label="E-mail de envio"
                                            name="emailenviofunc"
                                            value={funcionario.emailenviofunc || ''}
                                            variant="outlined"
                                            onChange={this.onChange}
                                            disabled={isView}
                                            inputProps={{ maxLength: 100 }}
                                            style={{
                                                flex: 1,
                                                minWidth: 220
                                            }}
                                        />
                                    </Box>

                                    <br />

                                    <Box
                                        display="flex"
                                        flexWrap="wrap"
                                        style={{ gap: 12 }}
                                    >
                                        <TextField
                                            label="Usuário"
                                            name="nomeusuarioemailenviofunc"
                                            value={funcionario.nomeusuarioemailenviofunc || ''}
                                            variant="outlined"
                                            onChange={this.onChange}
                                            disabled={isView}
                                            inputProps={{ maxLength: 100 }}
                                            style={{
                                                flex: 1,
                                                minWidth: 220
                                            }}
                                        />

                                        <TextField
                                            label="Senha"
                                            name="senhaemailenviofunc"
                                            value={funcionario.senhaemailenviofunc || ''}
                                            variant="outlined"
                                            onChange={this.onChange}
                                            disabled={isView}
                                            type={showSenha ? 'text' : 'password'}
                                            autoComplete="new-password"
                                            inputProps={{ maxLength: 100 }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <Tooltip title="Ver/ocultar senha">
                                                            <span>
                                                                {showSenha ? (
                                                                    <VisibilityOffOutlined
                                                                        onClick={this.handleToggleSenha}
                                                                        onMouseEnter={this.handleFieldIconMouseEnter}
                                                                        onMouseLeave={this.handleFieldIconMouseLeave}
                                                                        style={{
                                                                            fontSize: 22,
                                                                            marginTop: 4,
                                                                            color: isView ? theme.palette.grey[400] : theme.palette.primary.main,
                                                                            cursor: isView ? 'default' : 'pointer'
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <VisibilityOutlined
                                                                        onClick={this.handleToggleSenha}
                                                                        onMouseEnter={this.handleFieldIconMouseEnter}
                                                                        onMouseLeave={this.handleFieldIconMouseLeave}
                                                                        style={{
                                                                            fontSize: 22,
                                                                            marginTop: 4,
                                                                            color: isView ? theme.palette.grey[400] : theme.palette.primary.main,
                                                                            cursor: isView ? 'default' : 'pointer'
                                                                        }}
                                                                    />
                                                                )}
                                                            </span>
                                                        </Tooltip>
                                                    </InputAdornment>
                                                )
                                            }}
                                            style={{
                                                flex: 1,
                                                minWidth: 220
                                            }}
                                        />
                                    </Box>

                                    <br />

                                    <Box
                                        display="flex"
                                        flexWrap="wrap"
                                        alignItems="center"
                                        style={{ gap: 12 }}
                                    >
                                        <TextField
                                            label="Servidor SMTP"
                                            name="smtpemailfunc"
                                            value={funcionario.smtpemailfunc || ''}
                                            variant="outlined"
                                            onChange={this.onChange}
                                            disabled={isView}
                                            inputProps={{ maxLength: 100 }}
                                            style={{
                                                flex: 2,
                                                minWidth: 220
                                            }}
                                        />

                                        <TextField
                                            label="Porta SMTP"
                                            name="portasmtpemailfunc"
                                            value={getInputValue(funcionario.portasmtpemailfunc)}
                                            variant="outlined"
                                            onChange={this.handleNumericChange}
                                            disabled={isView}
                                            inputProps={{
                                                inputMode: 'numeric',
                                                pattern: '[0-9]*',
                                                maxLength: 5
                                            }}
                                            style={{
                                                flex: '0 1 140px',
                                                minWidth: 120
                                            }}
                                        />

                                        <TextField
                                            select
                                            label="Segurança da conexão"
                                            name="segconexemailfunc"
                                            value={String(funcionario.segconexemailfunc ?? '')}
                                            variant="outlined"
                                            onChange={this.onChange}
                                            disabled={isView}
                                            SelectProps={{ native: true }}
                                            InputLabelProps={{ shrink: true }}
                                            style={{
                                                flex: 1,
                                                minWidth: 180
                                            }}
                                        >
                                            <option
                                                value=""
                                            />

                                            {SEGURANCAS_CONEXAO.map(item => (
                                                <option
                                                    key={item.value}
                                                    value={item.value}
                                                >
                                                    {item.label}
                                                </option>
                                            ))}
                                        </TextField>
                                    </Box>

                                    <br />

                                    <Box
                                        display="flex"
                                        flexWrap="wrap"
                                        alignItems="center"
                                        style={{ gap: 12 }}
                                    >
                                        <FormControlLabel
                                            label={'Servidor requer autenticação'}
                                            control={
                                                <Checkbox
                                                    checked={funcionario.servreqautentemailfunc === ASIM}
                                                    name="servreqautentemailfunc"
                                                    onChange={this.onChange}
                                                    color="primary"
                                                    disabled={isView}
                                                />
                                            }
                                        />

                                        <FormControlLabel
                                            label={'Conexão SSL'}
                                            control={
                                                <Checkbox
                                                    checked={funcionario.servreqconexsslemailfunc === ASIM}
                                                    name="servreqconexsslemailfunc"
                                                    onChange={this.handleChangeConexaoSegura}
                                                    color="primary"
                                                    disabled={isView}
                                                />
                                            }
                                        />

                                        <FormControlLabel
                                            label={'Conexão TLS'}
                                            control={
                                                <Checkbox
                                                    checked={funcionario.servreqconextlsemailfunc === ASIM}
                                                    name="servreqconextlsemailfunc"
                                                    onChange={this.handleChangeConexaoSegura}
                                                    color="primary"
                                                    disabled={isView}
                                                />
                                            }
                                        />
                                    </Box>

                                    <br />

                                    <Box>
                                        <Typography
                                            color="textSecondary"
                                            component="p"
                                            variant="body2"
                                        >
                                            Texto padrão do corpo do e-mail
                                        </Typography>

                                        <FormTextArea
                                            name="textopadraocorpoemail"
                                            value={funcionario.textopadraocorpoemail}
                                            onChange={this.onChange}
                                            disabled={isView}
                                            minHeight={80}
                                        />
                                    </Box>

                                    <br />

                                    <FormControlLabel
                                        label={'Possui URL de assinatura'}
                                        control={
                                            <Checkbox
                                                checked={funcionario.possuiurlassinatura === ASIM}
                                                name="possuiurlassinatura"
                                                onChange={this.onChange}
                                                color="primary"
                                                disabled={isView}
                                            />
                                        }
                                    />

                                    {funcionario.possuiurlassinatura === ASIM && (
                                        <Box>
                                            <Typography
                                                color="textSecondary"
                                                component="p"
                                                variant="body2"
                                            >
                                                URL da assinatura
                                            </Typography>

                                            <FormTextArea
                                                name="urlassinatura"
                                                value={funcionario.urlassinatura}
                                                onChange={this.onChange}
                                                disabled={isView}
                                                minHeight={60}
                                            />
                                        </Box>
                                    )}
                                </div>
                            )}

                            {/* SUB-ABA IMAP */}
                            {emailTab === 1 && (
                                <div>
                                    <FormControlLabel
                                        label={'Usa IMAP para cópia de saída'}
                                        control={
                                            <Checkbox
                                                checked={funcionario.usaimapcopiasaida === ASIM}
                                                name="usaimapcopiasaida"
                                                onChange={this.onChange}
                                                color="primary"
                                                disabled={isView}
                                            />
                                        }
                                    />

                                    <br />
                                    <br />

                                    <Box
                                        display="flex"
                                        flexWrap="wrap"
                                        style={{ gap: 12 }}
                                    >
                                        <TextField
                                            label="Servidor IMAP"
                                            name="hostimap"
                                            value={funcionario.hostimap || ''}
                                            variant="outlined"
                                            onChange={this.onChange}
                                            disabled={isView || funcionario.usaimapcopiasaida !== ASIM}
                                            inputProps={{ maxLength: 100 }}
                                            style={{
                                                flex: 2,
                                                minWidth: 220
                                            }}
                                        />

                                        <TextField
                                            label="Porta IMAP"
                                            name="portaimap"
                                            value={getInputValue(funcionario.portaimap)}
                                            variant="outlined"
                                            onChange={this.handleNumericChange}
                                            disabled={isView || funcionario.usaimapcopiasaida !== ASIM}
                                            inputProps={{
                                                inputMode: 'numeric',
                                                pattern: '[0-9]*',
                                                maxLength: 5
                                            }}
                                            style={{
                                                flex: '0 1 140px',
                                                minWidth: 120
                                            }}
                                        />
                                    </Box>
                                </div>
                            )}

                            <br />
                            <br />

                            <FormActions
                                onSave={this.onClickSave}
                                onCancel={this.onClickCancel}
                                disableSave={isView}
                            />
                        </CardContent>
                    </TabContainer>
                }

                {/* ABA DOCUMENTOS */}
                {activeTab === 3 &&
                    <TabContainer>
                        <CardContent>
                            {titulo}

                            <br />

                            <FormLabel
                                component="legend"
                                disabled={isView}
                                style={{
                                    textAlign: 'center',
                                    backgroundColor: theme.palette.grey[300],
                                    padding: 3
                                }}
                            >
                                Documentos do funcionário
                            </FormLabel>

                            <TableContainer
                                component={Paper}
                                style={{
                                    overflowX: 'auto',
                                    width: '100%'
                                }}
                            >
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">
                                                Descrição
                                            </TableCell>

                                            <TableCell align="center">
                                                Vencimento
                                            </TableCell>

                                            <TableCell align="center">
                                                Inativo
                                            </TableCell>

                                            <TableCell align="center">
                                                Ações
                                            </TableCell>

                                            <TableCell align="center">
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'flex-end',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={this.handleOpenModalDocumentos}
                                                        disabled={isView}
                                                        style={{
                                                            color: 'black',
                                                            padding: '4px 12px'
                                                        }}
                                                    >
                                                        Inserir
                                                    </Button>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {documentosfuncionario.map((doc, index) => (
                                            <TableRow key={index}>
                                                <TableCell align="center">
                                                    {doc.descricao}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {formatData(doc.vencimento)}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {doc.inativodoc === ASIM ? 'Sim' : 'Não'}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <span style={iconGroup}>
                                                        <Tooltip title="Alterar">
                                                            <EditTwoTone
                                                                onMouseEnter={handleIconMouseEnter}
                                                                onMouseLeave={handleIconMouseLeave}
                                                                onClick={() => this.handleChangeDocumento(doc)}
                                                                style={actionIcon}
                                                            />
                                                        </Tooltip>

                                                        <Tooltip title="Excluir">
                                                            <DeleteForeverOutlined
                                                                onMouseEnter={handleDeleteIconMouseEnter}
                                                                onMouseLeave={handleIconMouseLeave}
                                                                onClick={() => this.handleOpenDeleteDocumento(
                                                                    doc.chave,
                                                                    doc.descricao,
                                                                    doc.chave && !String(doc.chave).startsWith('tmp-doc-') ? doc.chave : index + 1
                                                                )}
                                                                style={actionIcon}
                                                            />
                                                        </Tooltip>
                                                    </span>
                                                </TableCell>

                                                <TableCell />
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <br />
                            <br />

                            <FormActions
                                onSave={this.onClickSave}
                                onCancel={this.onClickCancel}
                                disableSave={isView}
                            />
                        </CardContent>
                    </TabContainer>
                }

                {/* MODAL DOCUMENTOS */}
                <Dialog
                    open={openModalDocumentos}
                    onClose={this.handleCloseModalDocumentos}
                    maxWidth="sm"
                    fullWidth
                >
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <DialogTitle>
                            Documentos
                        </DialogTitle>

                        <FormStatusSwitch
                            checked={documento.inativodoc === ANAO}
                            name="inativodoc"
                            onChange={this.onChangeDocumento}
                            disabled={isView}
                        />
                    </Box>

                    <DialogContent>
                        <Box>
                            <TextField
                                label="Funcionário"
                                value={funcionario.nome || ''}
                                variant="outlined"
                                disabled={isView}
                                InputProps={{
                                    readOnly: true,
                                    style: {
                                        color: 'rgba(0, 0, 0, 0.5)',
                                        backgroundColor: theme.palette.grey[100],
                                        pointerEvents: 'none'
                                    }
                                }}
                                style={{ backgroundColor: 'transparent' }}
                                fullWidth
                            />
                        </Box>

                        <br />

                        <Box>
                            <TextField
                                label="Descrição"
                                name="descricao"
                                value={documento.descricao || ''}
                                variant="outlined"
                                onChange={this.onChangeDocumento}
                                helperText={errors.descricao || ''}
                                error={!!errors.descricao}
                                disabled={isView}
                                inputProps={{ maxLength: 50 }}
                                fullWidth
                            />
                        </Box>

                        <br />

                        <Box
                            display="flex"
                            flexWrap="wrap"
                            style={{ gap: 12 }}
                        >
                            <TextField
                                label="Vencimento"
                                name="vencimento"
                                onChange={this.onChangeDocumento}
                                type="date"
                                value={getDateInputValue(documento.vencimento)}
                                variant="outlined"
                                disabled={isView}
                                InputLabelProps={{
                                    shrink: true,
                                    required: false
                                }}
                                style={{
                                    flex: 1,
                                    minWidth: 120
                                }}
                            />

                            <TextField
                                label="Avisar dias antes do vencimento"
                                name="avisodiasantecedencia"
                                value={getInputValue(documento.avisodiasantecedencia)}
                                variant="outlined"
                                disabled={isView}
                                type="number"
                                inputProps={{ min: 1 }}
                                onChange={this.handlePositiveNumberDocumentoChange}
                                style={{
                                    flex: 1,
                                    minWidth: 120
                                }}
                            />
                        </Box>

                        <br />

                        <Box>
                            <FileField
                                label="Local arquivo - TS"
                                value={documento.localdocts || ''}
                                inputRef={this.inputFileDocumentoTSRef}
                                onChange={this.handleFileDocumentoTS}
                                onRemove={this.handleOpenConfirmRemoveDocumentoTS}
                                disabled={isView}
                                accept="*/*"
                            />
                        </Box>

                        <br />

                        <Box>
                            <FileField
                                label="Local arquivo - rede interna"
                                value={documento.localdocredeint || ''}
                                inputRef={this.inputFileDocumentoRedeInternaRef}
                                onChange={this.handleFileDocumentoRedeInterna}
                                onRemove={this.handleOpenConfirmRemoveDocumentoRedeInterna}
                                disabled={isView}
                                accept="*/*"
                            />
                        </Box>

                        <br />

                        <Box>
                            <Typography
                                color="textSecondary"
                                component="p"
                                variant="body2"
                            >
                                Descritivo
                            </Typography>

                            <FormTextArea
                                name="descritivodoc"
                                value={documento.descritivodoc}
                                onChange={this.onChangeDocumento}
                                disabled={isView}
                                minHeight={80}
                            />
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button
                            onClick={this.handleCloseModalDocumentos}
                            color="secondary"
                        >
                            Cancelar
                        </Button>

                        <Button
                            onClick={this.onClickSaveDocumento}
                            color="primary"
                            disabled={isView}
                        >
                            Salvar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* MODAL CONFIRMAÇÃO MOTORISTA FORNECEDOR */}
                <Dialog
                    open={openConfirmMotorista}
                    onClose={this.handleCloseConfirmMotorista}
                    maxWidth="xs"
                    fullWidth
                >
                    <DialogTitle>
                        Confirmação
                    </DialogTitle>

                    <DialogContent>
                        <Typography variant="body1">
                            Confirma cadastro do funcionário também como motorista fornecedor?
                        </Typography>
                    </DialogContent>

                    <DialogActions>
                        <Button
                            onClick={this.handleCloseConfirmMotorista}
                            color="secondary"
                        >
                            Cancelar
                        </Button>

                        <Button
                            onClick={this.handleConfirmMotorista}
                            color="primary"
                        >
                            Confirmar
                        </Button>
                    </DialogActions>
                </Dialog>

                <DeleteConfirmationModal
                    open={openConfirmDeleteDocumento}
                    handleClose={this.handleCloseDeleteDocumento}
                    itemId={documentoASerExcluido}
                    message={`Confirma exclusão do documento do funcionário ${documentoDescASerExcluido || ''} [${documentoChaveASerExcluida}]?`}
                    handleDelete={this.handleConfirmDeleteDocumento}
                />

                <DeleteConfirmationModal
                    open={openConfirmRemoveDocumentoTS}
                    handleClose={this.handleCloseConfirmRemoveDocumentoTS}
                    itemId=""
                    message={"Confirma remoção do arquivo TS?"}
                    handleDelete={this.handleConfirmRemoveDocumentoTS}
                />

                <DeleteConfirmationModal
                    open={openConfirmRemoveDocumentoRedeInterna}
                    handleClose={this.handleCloseConfirmRemoveDocumentoRedeInterna}
                    itemId=""
                    message={"Confirma remoção do arquivo de rede interna?"}
                    handleDelete={this.handleConfirmRemoveDocumentoRedeInterna}
                />

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

FuncionarioForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object,
    loadFuncionarios: PropTypes.func
};

export default FuncionarioForm;